module.exports = {
  PERIOD: 'period',
  FROM: 'from',
  TO: 'to',
};
